export default "__VITE_ASSET__DDm3Y$_b__"